<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <div justify="center" align="center">
          <v-img
            src="../assets/logo.png"
            alt="url_logo"
            max-height="150"
            max-width="150"
            position="center center"
          >
          </v-img>
        </div>
        <div
          class="pa-4 display-1 medium white--text"
          align="center"
          justify="center"
        >
          {{ parametres.AppName }}
        </div>
        <v-alert class="my-4" v-if="isAuthenticated" type="info">
          Vous êtes actuellement connecté en tant que
          <span class="font-weight-black">{{ groupeFromUser.email }} </span>,
          pour continuer cliquer ici :
          <v-btn @click="goBack" fab rounded color="primary">
            <v-icon dark>mdi-home</v-icon></v-btn
          >
          <span> Sinon connectez-vous ci-dessous avec vos codes d'accès</span>
        </v-alert>

        <v-card
          flat
          class="v-card-login mx-auto pt-4"
          round
          max-width="400"
          min-width="320"
        >
          <v-card-text class="px-10 transparent">
            <v-form>
              <v-text-field
                autocomplete="email"
                v-model="email"
                :label="$lang.emailAddress"
                prepend-icon="email"
              ></v-text-field>

              <v-text-field
                autocomplete="current-password"
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                :label="$lang.password"
                prepend-icon="mdi-form-textbox-password"
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-10">
            <v-btn
              @click="loginButtonPressed"
              block
              rounded
              color="transparent"
              class="mb-6 neumorphic"
              >{{ $lang.login }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      email: "",
      password: "",
      show1: false,
    };
  },

  methods: {
    goBack() {
      this.$router.push("/");
    },
    async loginButtonPressed() {
      this.userLogin({
        email: this.email,
        password: this.password,
      });

      var logdata = {
        action: "Login",
        value: this.email,
      };

      this.createLog(logdata);
    },

    ...mapActions({
      userLogin: "Auth/userLogin",
      createLog: "Logs/createLog",
    }),
  },

  computed: {
    ...mapState({
      parametres: (state) => state.Parametres.parametres,
      groupeFromUser: (state) => state.Auth.user,
      isAuthenticated: (state) => state.Auth.isAuthenticated,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isOperateur: (state) => state.Auth.isOperateur,
      isGroupe: (state) => state.Auth.isGroupe,
    }),
  },
};
</script>
<style scoped></style>
